// @flow

import type {Language, TabName} from '@/types'

import React from 'react'
import GoAlert from 'react-icons/lib/go/alert'
import GoFileText from 'react-icons/lib/go/file-text'
import GoHome from 'react-icons/lib/go/home'
import GoPerson from 'react-icons/lib/go/person'
import GoSearch from 'react-icons/lib/go/search'
import styled, {css} from 'styled-components'
import {selectThemeColours} from '../theme-colours'
import {getSessionPartnerId} from '@/partnerID'

import {connect} from 'react-redux'
import {appSelectors} from '../store'

type Props = {
  l: Language,
  activeTab: TabName,
  handleTabChange: (string) => void,
}

const TabSection = styled.li`
${(props) => props.isActiveTab && css`
  color: ${props.themeColours.secondaryColour};
  background-color: #ffffff;
  border: 1px solid #dddddd;
  border-bottom-color: transparent;
  cursor: pointer;
  margin-right: 2px;
  line-height: 1.42857143;
  border-radius: 4px 4px 0 0;`
}
`

const ifSelected = (activeTab: TabName) => (s: TabName) =>
  s === activeTab

export const Nav = (props: Props) => {
  const themeColour = selectThemeColours(getSessionPartnerId())
  const activeClass = ifSelected(props.activeTab)
  return (
    <ul className="nav nav-tabs header-tabs">
      <TabSection isActiveTab={activeClass('home')} themeColours={themeColour}>
        <a id="home" onClick={() => props.handleTabChange('home')}><GoHome/> {props.l('Home')}</a>
      </TabSection>
      <TabSection isActiveTab={activeClass('portfolios')} themeColours={themeColour}>
        <a id="portfolios" onClick={() => props.handleTabChange('portfolios')}><GoPerson/> {props.l('Portfolios')}</a>
      </TabSection>
      <TabSection isActiveTab={activeClass('settings')} themeColours={themeColour}>
        <a id="notification_rules" onClick={() => props.handleTabChange('settings')}><GoAlert/> {props.l('Notification rules')}</a>
      </TabSection>
      <TabSection isActiveTab={activeClass('exports')} themeColours={themeColour}>
        <a id="exports" onClick={() => props.handleTabChange('exports')}><GoFileText/> {props.l('Exports')}</a>
      </TabSection>
      <TabSection isActiveTab={activeClass('analysis')} themeColours={themeColour}>
        <a id="analysis" onClick={() => props.handleTabChange('analysis')}><GoSearch/> {props.l('Analysis')}</a>
      </TabSection>
    </ul>
  )
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(Nav)



// WEBPACK FOOTER //
// ./src/controls/nav.js